import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

import SignaturePad from 'signature_pad';
// import mergeImages from 'merge-images'
import { DEFAULT_OPTIONS, TRANSPARENT_PNG, IMAGE_TYPES, checkSaveType, convert2NonReactive } from '../utils/index';

export default {
  name: 'VueSignaturePad',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      signaturePad: {},
      cacheImages: [],
      signatureData: TRANSPARENT_PNG,
      onResizeHandler: null
    };
  },
  computed: {
    propsImagesAndCustomImages: function propsImagesAndCustomImages() {
      var nonReactiveProrpImages = convert2NonReactive(this.images);
      var nonReactiveCachImages = convert2NonReactive(this.cacheImages);
      return [].concat(_toConsumableArray(nonReactiveProrpImages), _toConsumableArray(nonReactiveCachImages));
    },
    canvas: function canvas() {
      return this.$refs.signaturePadCanvas;
    }
  },
  watch: {
    options: function options(nextOptions) {
      var _this = this;

      _Object$keys(nextOptions).forEach(function (option) {
        if (_this.signaturePad[option]) {
          _this.signaturePad[option] = nextOptions[option];
        }
      });
    },
    height: function height() {
      this.resizeCanvas();
    }
  },
  mounted: function mounted() {
    var options = this.options;

    var canvas = this.$refs.signaturePadCanvas;
    var signaturePad = new SignaturePad(canvas, _extends({}, DEFAULT_OPTIONS, options));
    this.signaturePad = signaturePad;
    this.onResizeHandler = this.resizeCanvas.bind(this);
    window.addEventListener('resize', this.onResizeHandler, false);
    this.resizeCanvas();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.onResizeHandler) {
      window.removeEventListener('resize', this.onResizeHandler, false);
    }
  },

  methods: {
    resizeCanvas: function resizeCanvas() {
      var canvas = this.$refs.signaturePadCanvas;
      var data = this.signaturePad.toData();
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
      this.signatureData = TRANSPARENT_PNG;
      this.signaturePad.fromData(data);
    },
    saveSignature: function saveSignature() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IMAGE_TYPES[0];
      var encoderOptions = arguments[1];
      var signaturePad = this.signaturePad;

      var status = { isEmpty: false, data: undefined };
      if (!checkSaveType(type)) {
        var imageTypesString = IMAGE_TYPES.join(', ');
        throw new Error('The Image type is incorrect! We are support ' + imageTypesString + ' types.');
      }
      if (signaturePad.isEmpty()) {
        return _extends({}, status, {
          isEmpty: true
        });
      } else {
        this.signatureData = signaturePad.toDataURL(type, encoderOptions);
        return _extends({}, status, {
          data: this.signatureData
        });
      }
    },
    undoSignature: function undoSignature() {
      var signaturePad = this.signaturePad;

      var record = signaturePad.toData();
      if (record) {
        return signaturePad.fromData(record.slice(0, -1));
      }
    },

    // mergeImageAndSignature(customSignature) {
    //   this.signatureData = customSignature
    //   return mergeImages([
    //     ...this.images,
    //     ...this.cacheImages,
    //     this.signatureData
    //   ])
    // },
    // addImages(images = []) {
    //   this.cacheImages = [...this.cacheImages, ...images]
    //   return mergeImages([
    //     ...this.images,
    //     ...this.cacheImages,
    //     this.signatureData
    //   ])
    // },
    fromDataURL: function fromDataURL(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];

      return this.signaturePad.fromDataURL(data, options, callback);
    },
    fromData: function fromData(data) {
      return this.signaturePad.fromData(data);
    },
    toData: function toData() {
      return this.signaturePad.toData();
    },
    lockSignaturePad: function lockSignaturePad() {
      return this.signaturePad.off();
    },
    openSignaturePad: function openSignaturePad() {
      return this.signaturePad.on();
    },
    isEmpty: function isEmpty() {
      return this.signaturePad.isEmpty();
    },
    getPropImagesAndCacheImages: function getPropImagesAndCacheImages() {
      return this.propsImagesAndCustomImages;
    },
    clearCacheImages: function clearCacheImages() {
      this.cacheImages = [];
      return this.cacheImages;
    },
    clearSignature: function clearSignature() {
      return this.signaturePad.clear();
    },
    toBlob: function toBlob(callback, type, encoderOptions) {
      this.$refs.signaturePadCanvas.toBlob(callback, type, encoderOptions);
    }
  },
  render: function render(createElement) {
    var width = this.width,
        height = this.height,
        customStyle = this.customStyle;

    var urlObj = require('./signature.png');
    return createElement('div', {
      style: _extends({
        width: width,
        height: height
      }, customStyle)
    }, [createElement('canvas', {
      style: {
        width: '100%',
        height: '100%',
        cursor: 'url(' + urlObj + '),default'
      },
      ref: 'signaturePadCanvas'
    })]);
  }
};